import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  Grid,
  Table,
  Dimmer,
  Loader,
  Icon,
  Segment,
  Divider,
  List,
} from 'semantic-ui-react';
import { replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import qs from 'qs';
import _ from 'lodash';
import { decodeSearch, encodeSearch } from '../../utils/url';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import config from '../../../config';
import BookingSelectList from '../Filters/BookingSelectList';
import BANK_CASE_STATUSES, { CURRENT_STATUSES, CLOSED_STATUSES } from '../../constants/bankCaseStatuses';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

export const sortItems = [
  {
    text: 'Bank Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'bank.short_name',
    sortDirection: 'asc',
    status: null,
  },
  {
    text: 'Bank Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'bank.short_name',
    sortDirection: 'desc',
    status: null,
  },
  {
    text: 'New Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'average_new_age',
    sortDirection: 'asc',
    status: 'new',
  },
  {
    text: 'New Descending',
    icon: 'sort numeric descending',
    sortColumn: 'average_new_age',
    sortDirection: 'desc',
    status: 'new',
  },
  {
    text: 'Pending Docs Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'average_pending_docs_age',
    sortDirection: 'asc',
    status: 'pending_docs',
  },
  {
    text: 'Pending Docs Descending',
    icon: 'sort numeric descending',
    sortColumn: 'average_pending_docs_age',
    sortDirection: 'desc',
    status: 'pending_docs',
  },
  {
    text: 'Docs Submitted Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'average_pending_docs_submitted_age',
    sortDirection: 'asc',
    status: 'pending_docs_submitted',
  },
  {
    text: 'Docs Submitted Descending',
    icon: 'sort numeric descending',
    sortColumn: 'average_pending_docs_submitted_age',
    sortDirection: 'desc',
    status: 'pending_docs_submitted',
  },
  {
    text: 'LO Issued Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'average_approved_lo_issued_age',
    sortDirection: 'asc',
    status: 'approved_lo_issued',
  },
  {
    text: 'LO Issued Descending',
    icon: 'sort numeric descending',
    sortColumn: 'average_approved_lo_issued_age',
    sortDirection: 'desc',
    status: 'approved_lo_issued',
  },
  {
    text: 'Unreachable Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'average_pending_unreachable_age',
    sortDirection: 'asc',
    status: 'pending_unreachable',
  },
  {
    text: 'Unreachable Descending',
    icon: 'sort numeric descending',
    sortColumn: 'average_pending_unreachable_age',
    sortDirection: 'desc',
    status: 'pending_unreachable',
  },
  {
    text: 'Loan Re-appealed Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'average_pending_reappealed_age',
    sortDirection: 'asc',
    status: 'pending_reappealed',
  },
  {
    text: 'Loan Re-appealed Descending',
    icon: 'sort numeric descending',
    sortColumn: 'average_pending_reappealed_age',
    sortDirection: 'desc',
    status: 'pending_reappealed',
  },
  {
    text: 'Wrong Info Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'average_reject_wrong_info_age',
    sortDirection: 'asc',
    status: 'reject_wrong_info',
  },
  {
    text: 'Wrong Info Descending',
    icon: 'sort numeric descending',
    sortColumn: 'average_reject_wrong_info_age',
    sortDirection: 'desc',
    status: 'reject_wrong_info',
  },
  {
    text: 'Customer Cancelled Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'average_reject_cancelled_age',
    sortDirection: 'asc',
    status: 'reject_cancelled',
  },
  {
    text: 'Customer Cancelled Descending',
    icon: 'sort numeric descending',
    sortColumn: 'average_reject_cancelled_age',
    sortDirection: 'desc',
    status: 'reject_cancelled',
  },
  {
    text: 'LO Signed Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'average_success_li_issued_age',
    sortDirection: 'asc',
    status: 'success_li_issued',
  },
  {
    text: 'LO Signed Descending',
    icon: 'sort numeric descending',
    sortColumn: 'average_success_li_issued_age',
    sortDirection: 'desc',
    status: 'success_li_issued',
  },
  {
    text: 'Unqualified Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'average_reject_unqualified_age',
    sortDirection: 'asc',
    status: 'reject_unqualified',
  },
  {
    text: 'Unqualified Descending',
    icon: 'sort numeric descending',
    sortColumn: 'average_reject_unqualified_age',
    sortDirection: 'desc',
    status: 'reject_unqualified',
  },
  {
    text: 'Loan Rejected Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'average_reject_bank_age',
    sortDirection: 'asc',
    status: 'reject_bank',
  },
  {
    text: 'Loan Rejected Descending',
    icon: 'sort numeric descending',
    sortColumn: 'average_reject_bank_age',
    sortDirection: 'desc',
    status: 'reject_bank',
  },
  {
    text: 'Customer Rejected Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'average_reject_customer_age',
    sortDirection: 'asc',
    status: 'reject_customer',
  },
  {
    text: 'Customer Rejected Descending',
    icon: 'sort numeric descending',
    sortColumn: 'average_reject_customer_age',
    sortDirection: 'desc',
    status: 'reject_customer',
  },
  {
    text: 'LO Signed With Another Bank Descending',
    icon: 'sort numeric descending',
    sortColumn: 'average_reject_lo_signed_other_bank_age',
    sortDirection: 'desc',
    status: 'reject_lo_signed_other_bank',
  },
  {
    text: 'LO Signed With Another Bank Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'average_reject_lo_signed_other_bank_age',
    sortDirection: 'asc',
    status: 'reject_lo_signed_other_bank',
  },
  {
    text: 'Developer Cancelled Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'average_reject_developer_age',
    sortDirection: 'asc',
    status: 'reject_developer',
  },
  {
    text: 'Developer Cancelled Descending',
    icon: 'sort numeric descending',
    sortColumn: 'average_reject_developer_age',
    sortDirection: 'desc',
    status: 'reject_developer',
  },
  {
    text: 'Current Total Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'total_current_average',
    sortDirection: 'asc',
    status: 'total_current_average',
  },
  {
    text: 'Current Total Descending',
    icon: 'sort numeric descending',
    sortColumn: 'total_current_average',
    sortDirection: 'desc',
    status: 'total_current_average',
  },
  {
    text: 'Closed Total Ascending',
    icon: 'sort numeric ascending',
    sortColumn: 'total_closed_average',
    sortDirection: 'asc',
    status: 'total_closed_average',
  },
  {
    text: 'Closed Total Descending',
    icon: 'sort numeric descending',
    sortColumn: 'total_closed_average',
    sortDirection: 'desc',
    status: 'total_closed_average',
  },
];

class BankAverageAging extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    headerColor: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }).isRequired,
    onFilterChange: PropTypes.func,
    onFilterClose: PropTypes.func,
    t: PropTypes.func,
  }
  static getQueryData = (props) => {
    const query = decodeSearch(props.location.search);
    const projectID = query.projectID || '';
    const sortColumn = query.sortColumn || '';
    const sortDirection = query.sortDirection || '';
    const search = query.search || '';
    const dateRange = query.dateRange || '';
    const dateFrom = query.dateFrom ? query.dateFrom : '';
    const dateTo = query.dateTo ? query.dateTo : '';
    const bankID = query.bankID ? query.bankID : [];
    const statusGroup = query.statusGroup || 'all';
    const status = query.status ? query.status : '';
    return {
      bankID,
      projectID,
      sortColumn,
      sortDirection,
      search,
      dateRange,
      dateFrom,
      dateTo,
      statusGroup,
      status,
    };
  }
  static getPropsToState = (props) => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    const query = decodeSearch(props.location.search);
    const status = query.status || '';
    return {
      isMobile,
      status,
    };
  }
  constructor(props) {
    super(props);
    const state = BankAverageAging.getPropsToState(props);
    this.state = {
      ...state,
      data: [],
      bankActives: [],
      loading: true,
    };
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);
    this.fetchReports(query);
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = BankAverageAging.getPropsToState(nextProps);
    const query = BankAverageAging.getQueryData(this.props);
    const newQuery = BankAverageAging.getQueryData(nextProps);
    const refetch = (
      !_.isEqual(query.projectID, newQuery.projectID) ||
      !_.isEqual(query.sortColumn, newQuery.sortColumn) ||
      !_.isEqual(query.sortDirection, newQuery.sortDirection) ||
      !_.isEqual(query.search, newQuery.search) ||
      !_.isEqual(query.dateRange, newQuery.dateRange) ||
      !_.isEqual(query.dateTo, newQuery.dateTo) ||
      !_.isEqual(query.dateFrom, newQuery.dateFrom) ||
      !_.isEqual(query.statusGroup, newQuery.statusGroup) ||
      !_.isEqual(query.status, newQuery.status) ||
      !_.isEqual(query.bankID, newQuery.bankID)
    );
    this.setState({ ...state }, () => {
      if (refetch) {
        const q = decodeSearch(nextProps.location.search);
        this.fetchReports(q);
      }
    });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  getColSpan = () => {
    const { isMobile } = this.state;
    const { showCurrent, showClosed, showCustom } = this.checkStatus();
    if (showCustom) {
      return 2;
    }
    let span = 1; // bank column
    if (showCurrent) {
      const currentSpan = 1 + (isMobile ? 0 :
      CURRENT_STATUSES.filter(this.filterStatus).length);
      span += currentSpan;
    }
    if (showClosed) {
      const closedSpan = 1 + (isMobile ? 0 :
      CLOSED_STATUSES.filter(this.filterStatus).length);
      span += closedSpan;
    }
    return span;
  }
  handleResize = () => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  }
  handleCellSort = (key, defaultCell = false) => {
    const column = sortItems[key].sortColumn;
    const { sortColumn, sortDirection } = decodeSearch(this.props.location.search);
    let direction = 'asc';
    if (defaultCell && (sortColumn === undefined)) {
      direction = 'desc';
    }
    if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    this.handleSortData(column, direction);
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query);
  }
  handleTitleClick = (e, idx) => {
    const { bankActives } = this.state;
    bankActives[idx] = !bankActives[idx];
    this.setState({ bankActives });
  }
  cellCheckSorted(key, defaultCell = false) {
    const column = sortItems[key].sortColumn;
    const { sortColumn, sortDirection } = decodeSearch(this.props.location.search);
    if (defaultCell && (sortColumn === undefined)) {
      return 'ascending';
    }
    if (column === sortColumn) {
      return sortDirection === 'asc' ? 'ascending' : 'descending';
    }
    return null;
  }
  async fetchReports(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({}, q);
    delete query.projectID;
    const projectID = q.projectID || '';
    if (projectID !== '') {
      query.projectID = projectID;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/reports/bookings/banks/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      const bankActives = data.bankReports.map(() => false);
      await this.setComponentState({
        data,
        bankActives,
      });
    }
    await this.setLoading(false);
  }
  replaceQuery(query) {
    const { store } = this.context;
    const { pathname } = this.props.location;
    const queryNew = query;
    store.dispatch(replace(`${pathname}?${encodeSearch(queryNew)}`));
  }
  filterStatus = (cs) => {
    const { status, statusGroup } = BankAverageAging.getQueryData(this.props);
    switch (statusGroup) {
      case 'current':
        return CURRENT_STATUSES.some(s => cs === s);
      case 'closed':
        return CLOSED_STATUSES.some(s => cs === s);
      case 'custom':
        if (status && status.length > 0) {
          return status.some(s => s === cs);
        }
        break;
      default:
    }
    return true;
  }
  filterStatusCount = (cs, bankData) => {
    const count = bankData[_.camelCase(`average_${cs}_age`)];
    const { status, statusGroup } = BankAverageAging.getQueryData(this.props);
    if (statusGroup && statusGroup === 'custom' && status !== '') {
      return cs === status;
    }
    return count > 0;
  }
  checkStatus = () => {
    const { statusGroup } = BankAverageAging.getQueryData(this.props);
    const showCurrent = statusGroup === 'all' || statusGroup === 'current';
    const showClosed = statusGroup === 'all' || statusGroup === 'closed';
    const showCustom = statusGroup === 'custom';
    return {
      showCurrent,
      showClosed,
      showCustom,
    };
  }
  renderHeaderCell = (status, idx, className) => {
    if (sortItems.some(item => item.status === status)) {
      const { isMobile } = this.state;
      const { t } = this.props;
      const { statusGroup } = BankAverageAging.getQueryData(this.props);
      const key = sortItems.findIndex(item => item.status === status);
      const statusItem = sortItems.find(item => item.status === status);
      const text = statusItem.text.substring(0, statusItem.text.lastIndexOf(' '));
      const translatedText = t(text, { ns: TRANSLATION_FILES.constants });
      return (
        <Table.HeaderCell
          key={idx}
          className={className}
          sorted={this.cellCheckSorted(key)}
          onClick={(isMobile || statusGroup !== 'all') ? () => this.handleCellSort(key) : null}
        >
          {
            (isMobile || statusGroup !== 'all') ? (
              <Fragment>
                <small>{translatedText}</small>
                &nbsp;
                {
                  this.cellCheckSorted(key) ? null : (
                    <Icon
                      inverted color="grey"
                      name="sort"
                    />
                  )
                }
              </Fragment>
            ) : <div className="text">{translatedText}</div>
          }
        </Table.HeaderCell>
      );
    }
    return null;
  }
  renderDataCell = (status, idx, bankData) => (
    <Table.Cell
      key={idx}
      textAlign="right"
    >
      {bankData[_.camelCase(`average_${status}_age`)]}
    </Table.Cell>
  )
  renderListItem = (status, idx, bankData) => {
    if (sortItems.some(item => item.status === status)) {
      const { t } = this.props;
      const statusItem = sortItems.find(item => item.status === status);
      const text = statusItem.text.substring(0, statusItem.text.lastIndexOf(' '));
      const count = bankData[_.camelCase(`average_${status}_age`)];
      return (
        <List.Item key={idx}>
          <List.Content>
            <small style={{ float: 'left' }}>{t(text, { ns: TRANSLATION_FILES.constants })}</small>
            <small style={{ float: 'right' }}>{count}</small>
          </List.Content>
        </List.Item>
      );
    }
    return null;
  }
  renderTableHeader = () => {
    const { isMobile } = this.state;
    const { t } = this.props;
    const { statusGroup } = BankAverageAging.getQueryData(this.props);
    const { showCurrent, showClosed, showCustom } = this.checkStatus();
    const key = sortItems.findIndex(item => item.status === this.state.status);
    const currentTotalkey = sortItems.findIndex(item => item.sortColumn === 'total_current_average');
    const closedTotalkey = sortItems.findIndex(item => item.sortColumn === 'total_closed_average');
    return (
      <Table.Row style={{ borderBottom: '#bbb 2px solid' }} verticalAlign="bottom">
        <Table.HeaderCell
          className="bank bold"
          sorted={this.cellCheckSorted(0, true)}
          onClick={(isMobile || statusGroup !== 'all') ? () => this.handleCellSort(0, true) : null}
        >
          {
            (isMobile || statusGroup !== 'all') ? (
              <Fragment>
                <small>{t('Bank')}</small>
                &nbsp;
                {
                  this.cellCheckSorted(0, true) ? null : (
                    <Icon
                      inverted color="grey"
                      name="sort"
                    />
                  )
                }
              </Fragment>
            ) : <div className="text">{t('Bank')}</div>
          }
        </Table.HeaderCell>
        {
          showCustom && (
            <Table.HeaderCell
              sorted={key > 0 ? this.cellCheckSorted(key) : null}
              onClick={key > 0 ? () => this.handleCellSort(key) : null}
              style={{ display: 'flex' }}
            >
              <BookingSelectList
                style={{ flex: 1 }}
                filterName="status"
                onChange={this.props.onFilterChange}
                onClose={this.props.onFilterClose}
                options={BANK_CASE_STATUSES.map(s => ({
                  ...s,
                  text: t(s.text, { ns: TRANSLATION_FILES.constants }),
                }))}
                placeholder={t('Select Status')}
                value={this.state.status}
                disabled={this.state.loading}
              />
              {
                key > 0 && (this.cellCheckSorted(key) ? null :
                <Icon
                  inverted color="grey"
                  name="sort"
                />)
              }
            </Table.HeaderCell>
          )
        }
        {
          !isMobile && showCurrent &&
          CURRENT_STATUSES.filter(this.filterStatus).map((s, idx) => this.renderHeaderCell(s, idx, 'current'))
        }
        {
          (showCurrent || (isMobile && !showClosed && !showCurrent && !showCustom)) && (
            <Table.HeaderCell
              className="current bold"
              sorted={this.cellCheckSorted(currentTotalkey)}
              onClick={(isMobile || statusGroup !== 'all') ? () => this.handleCellSort(currentTotalkey) : null}
              style={showClosed ? {
                borderLeft: '#bbb 2px solid',
                borderRight: '2px solid #2185D0',
              } : { borderLeft: '#bbb 2px solid' }}
            >
              {
                (isMobile || statusGroup !== 'all') ? (
                  <Fragment>
                    <small>{t('Current Total')}</small>
                    &nbsp;
                    {
                      this.cellCheckSorted(currentTotalkey) ? null : (
                        <Icon
                          inverted color="grey"
                          name="sort"
                        />
                      )
                    }
                  </Fragment>
                ) : <div className="text">{t('Current Total')}</div>
              }
            </Table.HeaderCell>
          )
        }
        {
          !isMobile && showClosed &&
          CLOSED_STATUSES.filter(this.filterStatus).map((s, idx) => this.renderHeaderCell(s, idx, 'closed'))
        }
        {
          (showClosed || (isMobile && !showClosed && !showCurrent && !showCustom)) && (
            <Table.HeaderCell
              className="closed bold"
              sorted={this.cellCheckSorted(closedTotalkey)}
              onClick={(isMobile || statusGroup !== 'all') ? () => this.handleCellSort(closedTotalkey) : null}
              style={{ borderLeft: '#bbb 2px solid' }}
            >
              {
                (isMobile || statusGroup !== 'all') ? (
                  <Fragment>
                    <small>{t('Closed Total')}</small>
                    &nbsp;
                    {
                      this.cellCheckSorted(closedTotalkey) ? null : (
                        <Icon
                          inverted color="grey"
                          name="sort"
                        />
                      )
                    }
                  </Fragment>
                ) : <div className="text">{t('Closed Total')}</div>
              }
            </Table.HeaderCell>
          )
        }
      </Table.Row>
    );
  }
  renderTableBody = (item, idx, arr) => {
    const { isMobile, bankActives } = this.state;
    const { status } = BankAverageAging.getQueryData(this.props);
    const { showCurrent, showClosed, showCustom } = this.checkStatus();
    return (
      <Table.Row
        key={idx}
        verticalAlign="top"
        style={idx === arr.length - 1 ? { borderBottom: '#bbb 2px solid' } : null}
      >
        <Table.Cell>
          {
            isMobile && !showCustom ? (
              <Accordion>
                <Accordion.Title
                  active={bankActives[idx]}
                  onClick={e => this.handleTitleClick(e, idx)}
                >
                  {item.bank && item.bank.shortName}
                  <Icon name={`angle ${bankActives[idx] ? 'down' : 'right'}`} style={{ float: 'right' }} />
                </Accordion.Title>
              </Accordion>
            ) : item.bank && item.bank.shortName
          }
        </Table.Cell>
        {
          showCustom && (
            <Table.Cell textAlign="right">
              {status && status !== '' && item[_.camelCase(`average_${status}_age`)]}
            </Table.Cell>
          )
        }
        {
          !isMobile && showCurrent && CURRENT_STATUSES.filter(this.filterStatus)
          .map((state, sidx) => this.renderDataCell(state, sidx, item))
        }
        {
          (showCurrent || (isMobile && !showClosed && !showCurrent && !showCustom)) && (
            <Table.Cell
              textAlign="right"
              style={showClosed ? {
                borderLeft: '#bbb 2px solid',
                borderRight: '2px solid #2185D0',
              } : { borderLeft: '#bbb 2px solid' }}
            >
              {
                isMobile ? (
                  <Accordion>
                    <Accordion.Title
                      active={bankActives[idx]}
                      onClick={e => this.handleTitleClick(e, idx)}
                    >
                      <strong style={{ fontSize: '1.1em' }}>{item.totalCurrentAverage}</strong>
                    </Accordion.Title>
                    {
                      showCurrent && (
                        <Accordion.Content active={bankActives[idx]}>
                          <List relaxed>
                            {CURRENT_STATUSES.map((cs, i) => this.renderListItem(cs, i, item))}
                          </List>
                        </Accordion.Content>
                      )
                    }
                  </Accordion>
                ) : (
                  <strong style={{ fontSize: '1.1em' }}>{item.totalCurrentAverage}</strong>
                )
              }
            </Table.Cell>
          )
        }
        {
          !isMobile && showClosed && CLOSED_STATUSES.filter(this.filterStatus)
          .map((state, sidx) => this.renderDataCell(state, sidx, item))
        }
        {
          (showClosed || (isMobile && !showClosed && !showCurrent && !showCustom)) && (
            <Table.Cell
              textAlign="right"
              style={{ borderLeft: '#bbb 2px solid' }}
            >
              {
                isMobile ? (
                  <Accordion>
                    <Accordion.Title
                      active={bankActives[idx]}
                      onClick={e => this.handleTitleClick(e, idx)}
                    >
                      <strong style={{ fontSize: '1.1em' }}>{item.totalClosedAverage}</strong>
                    </Accordion.Title>
                    {
                      showClosed && (
                        <Accordion.Content active={bankActives[idx]}>
                          <List relaxed>
                            {CLOSED_STATUSES.map((cs, i) => this.renderListItem(cs, i, item))}
                          </List>
                        </Accordion.Content>
                      )
                    }
                  </Accordion>
                ) : (
                  <strong style={{ fontSize: '1.1em' }}>{item.totalClosedAverage}</strong>
                )
              }
            </Table.Cell>
          )
        }
      </Table.Row>
    );
  }
  renderTotalRow = () => {
    const { data, isMobile } = this.state;
    const { status } = BankAverageAging.getQueryData(this.props);
    const { showCurrent, showClosed, showCustom } = this.checkStatus();
    let totalAverage = 0;
    if (showCustom) {
      if (status === '') {
        return null;
      }
      if (CURRENT_STATUSES.some(s => s === status)) {
        totalAverage = data.totalCurrentAverage;
      } else if (CLOSED_STATUSES.some(s => s === status)) {
        totalAverage = data.totalClosedAverage;
      }
    }
    return (
      <Table.Row style={{ borderBottom: '#bbb 2px solid' }}>
        {
          (showCurrent || showCustom) && (
            <Table.Cell
              colSpan={1 + ((showCustom || isMobile) ? 0 :
              CURRENT_STATUSES.filter(this.filterStatus).length)}
            />
          )
        }
        {
          (showCurrent || (isMobile && !showClosed && !showCurrent && !showCustom)) && (
            <Table.Cell
              textAlign="right"
              style={showClosed ? {
                borderLeft: '#bbb 2px solid',
                borderRight: '2px solid #2185D0',
              } : { borderLeft: '#bbb 2px solid' }}
            >
              <strong style={{ fontSize: '1.2em' }}>{data.totalCurrentAverage}</strong>
            </Table.Cell>
          )
        }
        {
          (showClosed && ((isMobile && !showCurrent) || !isMobile)) && (
            <Table.Cell
              colSpan={(isMobile ? 0 :
              CLOSED_STATUSES.filter(this.filterStatus).length) +
                (showCurrent ? 0 : 1)}
            />
          )
        }
        {
          (showClosed || (isMobile && !showClosed && !showCurrent && !showCustom)) && (
            <Table.Cell
              textAlign="right"
              style={{ borderLeft: '#bbb 2px solid' }}
            >
              <strong style={{ fontSize: '1.2em' }}>{data.totalClosedAverage}</strong>
            </Table.Cell>
          )
        }
        {
          showCustom && (
            <Table.Cell textAlign="right">
              <strong style={{ fontSize: '1.2em' }}>{totalAverage}</strong>
            </Table.Cell>
          )
        }
      </Table.Row>
    );
  }
  render() {
    const { data } = this.state;
    const { t } = this.props;
    const { showCustom } = this.checkStatus();
    const { statusGroup } = BankAverageAging.getQueryData(this.props);
    const classNames = ['bank-report'];
    if (statusGroup === 'all') {
      classNames.push('vertical-header');
    }
    if (showCustom) {
      classNames.push('custom-group');
    }
    const filteredData = data && data.bankReports && data.bankReports.length > 0
      ? data.bankReports.filter(item => item.totalCurrentAverage > 0 || item.totalClosedAverage > 0)
      : [];
    return (
      <Grid style={{ margin: '-1rem 0' }}>
        <Grid.Row>
          <Grid.Column>
            <Segment color={this.props.headerColor}>
              <Grid>
                <Grid.Row className="users-bookings table">
                  <Grid.Column className="mobile-report-table">
                    <Dimmer
                      inverted style={{ zIndex: 20 }}
                      active={this.state.loading}
                    >
                      <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                    </Dimmer>
                    <Table
                      celled
                      compact
                      unstackable
                      structured
                      sortable={this.state.isMobile || statusGroup !== 'all'}
                      className={classNames.join(' ')}
                    >
                      <Table.Header>
                        {this.renderTableHeader()}
                      </Table.Header>
                      {
                        filteredData.length > 0 ? (
                          <Table.Body>
                            {
                              filteredData.map(this.renderTableBody)
                            }
                            {this.renderTotalRow()}
                          </Table.Body>
                        ) : (
                          <Table.Body>
                            <Table.Row>
                              <Table.Cell colSpan={this.getColSpan()}>
                                <Segment basic textAlign="center">
                                  {
                                    this.state.loading ? <Divider hidden />
                                    : `${t('No reports found')}.`
                                  }
                                </Segment>
                              </Table.Cell>
                            </Table.Row>
                          </Table.Body>
                        )
                      }
                    </Table>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(BankAverageAging);



// WEBPACK FOOTER //
// ./src/components/Reports/BankAverageAging.jsx